<template>
  <div class="content Tabs">

     <b-tabs card>
          <!-- <div class="categories" v-if="isPlugin">
              <CategoryComponent  :lang="lang.PluginCategory"></CategoryComponent>

          </div> -->

          <b-tab v-if="source=='PartTable' || source == 'PartDetails'" :title="lang.tab_NewPart"  :title-link-class="textColors" :title-item-class="textColors" active >

            <DerivePartFormComponent :lang="lang.DerivePartForm" :source="source"></DerivePartFormComponent>

          </b-tab>

          <b-tab v-if="source=='PartSearch'" :title="lang.tab_NewPartFound"  :title-link-class="textColors" :title-item-class="textColors" active >

            <DeriveSearchedPartFormComponent :lang="lang.DeriveSearchedPartForm"></DeriveSearchedPartFormComponent>

            <CreatePropsFromSearchedComponent :lang="lang.CreatePropertiesForm"></CreatePropsFromSearchedComponent>

          </b-tab>

        </b-tabs>

  </div>

</template>
<script>


import { mapGetters } from 'vuex'
import DerivePartFormComponent from '@/components/shared/DerivePartFormComponent'
import DeriveSearchedPartFormComponent from '@/components/shared/DeriveSearchedPartFormComponent'
import CreatePropsFromSearchedComponent from '@/components/shared/CreatePropsFromSearchedComponent'
import CategoryComponent from '@/components/shared/CategoryComponent'

export default {
  name: "Content",
  components: {
    DerivePartFormComponent,
    DeriveSearchedPartFormComponent,
    CreatePropsFromSearchedComponent,
    CategoryComponent
  },
  props:{
    lang: Object
  },
  data () {
    return {

    }
  },
  computed: {
    ...mapGetters([
      'isPlugin',
      
    ]),
    source(){

      return this.$route.query.source;
    },
    textColors(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return ['tabs-bg-dark', 'tabs-text-light']
      }else{
        return ['tabs-bg-light', 'tabs-text-dark']
      }

    }
  },
  created () {
    


  },
  updated() {


  },
  watch: {

  }
}
</script>

<style scooped>
  #DerivePartFormComponent{
    width: 60%;
  }

  .bv-example-row-max{
    max-width: 100%;
    padding-right: 0px;
    padding-left: 0px;
  }
  .categories{
    margin-left: 5px;
    margin-right: 5px;
  }

</style>



// WEBPACK FOOTER //
// src/components/PartManager/Views/PartDerive/Middle/Content/Content.vue